import { render } from "./detailsProductContent.vue?vue&type=template&id=47873aa8&scoped=true"
import script from "./detailsProductContent.vue?vue&type=script&lang=js"
export * from "./detailsProductContent.vue?vue&type=script&lang=js"

import "./detailsProductContent.vue?vue&type=style&index=0&id=47873aa8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47873aa8"]])

export default __exports__